module.exports = __webpack_public_path__ + "img/zh.9a273eb1.svg";